import { createSelector } from '@reduxjs/toolkit';
import { EVENT_STATUS_OPEN } from '@ogsnetwork/opp-api-lib';
import moment from 'moment';
export const pageFromPropsSelector = (state, props) => props.page;
export const customerSelector = (state) => state.customer.customer;
export const eventsByIdSelector = (state) => state.events.byId;
export const ticketsByIdSelector = (state) => state.tickets.byId;
export const ticketsByEventIdSelector = (state) => state.tickets.byEventId;
export const finalizedTicketIdsByPageSelector = (state) => state.tickets.byPage;
export const transactionsByIdSelector = (state) => state.transactions.byId;
export const transactionIdsByPageSelector = (state) => state.transactions.byPage;
export const ticketsWithEventsSelector = createSelector(eventsByIdSelector, ticketsByIdSelector, (eventsById, ticketsById) => Object.keys(ticketsById).map((ticketId) => {
    const ticket = ticketsById[ticketId];
    return Object.assign(Object.assign({}, ticket), { event: eventsById[ticket.eventId] });
}));
export const userTicketSelector = createSelector(customerSelector, ticketsWithEventsSelector, (customer, tickets) => tickets
    .filter((ticket) => { var _a, _b; return ticket.user === undefined || ((_a = ticket.user) === null || _a === void 0 ? void 0 : _a.username) === ((_b = customer === null || customer === void 0 ? void 0 : customer.user) === null || _b === void 0 ? void 0 : _b.username); })
    .sort((a, b) => b.id - a.id));
export const userTicketsByFinalizeSelector = createSelector(userTicketSelector, (userTickets) => userTickets.sort((firstTicket, secondTicket) => {
    if (moment(firstTicket.event.finalizeTs).isBefore(moment(secondTicket.event.finalizeTs))) {
        return 1;
    }
    if (moment(firstTicket.event.finalizeTs).isAfter(moment(secondTicket.event.finalizeTs))) {
        return -1;
    }
    return 0;
}));
export const userTicketsByCloseSelector = createSelector(userTicketSelector, (userTickets) => userTickets.sort((firstTicket, secondTicket) => {
    if (moment(firstTicket.event.closeTs).isBefore(moment(secondTicket.event.closeTs))) {
        return -1;
    }
    if (moment(firstTicket.event.closeTs).isAfter(moment(secondTicket.event.closeTs))) {
        return 1;
    }
    return 0;
}));
export const eventsSelector = createSelector(eventsByIdSelector, (eventsById) => Object.keys(eventsById).map((eventId) => eventsById[eventId]));
export const eventsFilterUserLocationAndSortSelector = createSelector(customerSelector, eventsSelector, (customer, events) => events
    .filter((event) => {
    var _a, _b;
    const province = (_a = customer === null || customer === void 0 ? void 0 : customer.currentProvince) !== null && _a !== void 0 ? _a : customer === null || customer === void 0 ? void 0 : customer.province;
    if ((_b = province === null || province === void 0 ? void 0 : province.freeContestsOnly) !== null && _b !== void 0 ? _b : true) {
        return event.ticketCost === 0 && event.payout === 0;
    }
    return true;
})
    .sort((firstEvent, secondEvent) => {
    var _a, _b;
    const firstEventSortOrder = (_a = firstEvent.sortOrder) !== null && _a !== void 0 ? _a : 0;
    const secondEventSortOrder = (_b = secondEvent.sortOrder) !== null && _b !== void 0 ? _b : 0;
    if (firstEventSortOrder !== 0 && secondEventSortOrder === 0) {
        return -1;
    }
    if (firstEventSortOrder === 0 && secondEventSortOrder !== 0) {
        return 1;
    }
    if (firstEventSortOrder - secondEventSortOrder !== 0) {
        return firstEventSortOrder - secondEventSortOrder;
    }
    if (moment(firstEvent.closeTs).isBefore(moment(secondEvent.closeTs))) {
        return -1;
    }
    if (moment(firstEvent.closeTs).isAfter(moment(secondEvent.closeTs))) {
        return 1;
    }
    return 0;
}));
export const openEventsSelector = createSelector(eventsFilterUserLocationAndSortSelector, (events) => events.filter((event) => event.status === EVENT_STATUS_OPEN));
export const openTicketsSelector = createSelector(userTicketSelector, openEventsSelector, (tickets, events) => tickets.filter((ticket) => events.findIndex((event) => event.id === ticket.eventId) !== -1));
export const makeFinalizedTicketsByPageSelector = () => createSelector(pageFromPropsSelector, finalizedTicketIdsByPageSelector, ticketsByIdSelector, eventsByIdSelector, (page, ticketIdsByPage, ticketById, eventsById) => {
    var _a;
    return ((_a = ticketIdsByPage[page]) !== null && _a !== void 0 ? _a : []).map((ticketId) => {
        const ticket = ticketById[ticketId];
        return Object.assign(Object.assign({}, ticket), { event: eventsById[ticket.eventId] });
    });
});
export const makeTransactionsByPageSelector = () => createSelector(pageFromPropsSelector, transactionIdsByPageSelector, transactionsByIdSelector, (page, transactionIdsByPage, transactionsById) => {
    var _a;
    return ((_a = transactionIdsByPage[page]) !== null && _a !== void 0 ? _a : []).map((transactionId) => transactionsById[transactionId]);
});
export const sortedTransactionsSelector = createSelector(transactionsByIdSelector, (transactionsById) => {
    return Object.values(transactionsById).sort((transactionA, transactionB) => transactionB.createdTimestamp - transactionA.createdTimestamp);
});
